import type { ILopDay } from "@/types/(company)/payrollRuns.interface";

export interface ILopDateRun {
  from: number;
  to: number;
  half: boolean;
}

export interface ILopMonth {
  /** Any date in the month, for its localized name. */
  monthDate: Date;
  runs: ILopDateRun[];
}

const dayOf = (iso: string) => Number(iso.slice(8, 10));
const monthKey = (iso: string) => iso.slice(0, 7);
const localDate = (iso: string) => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
};
const nextIso = (iso: string) => {
  const d = localDate(iso);
  d.setDate(d.getDate() + 1);
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
};

/**
 * Docked dates grouped by month, consecutive whole days as one run and each
 * half day on its own: Jun → 2, 15, 17–19, 29 (½). Pure, so it is tested
 * apart from the locale that names the months.
 */
export const groupLopDates = (dates: ILopDay[]): ILopMonth[] => {
  const sorted = [...dates].sort((a, b) => a.date.localeCompare(b.date));
  const months: ILopMonth[] = [];
  let lastKey = "";
  for (let i = 0; i < sorted.length;) {
    const start = sorted[i];
    const half = start.days < 1;
    let j = i;
    while (
      !half &&
      j + 1 < sorted.length &&
      sorted[j + 1].days >= 1 &&
      sorted[j + 1].date === nextIso(sorted[j].date) &&
      monthKey(sorted[j + 1].date) === monthKey(start.date)
    ) {
      j++;
    }
    if (monthKey(start.date) !== lastKey) {
      months.push({ monthDate: localDate(start.date), runs: [] });
      lastKey = monthKey(start.date);
    }
    months[months.length - 1].runs.push({
      from: dayOf(start.date),
      to: dayOf(sorted[j].date),
      half,
    });
    i = j + 1;
  }
  return months;
};
